import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { GlobalVariables } from '../../../../globalVar';
import customAxios from '../../../../utils/customAxios';
import { getToast } from '../../../../utils/toastConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const ChangeStatusModal = ({
  visitId,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [visitData, setVisitData] = useState({
    id: visitId,
    final_status_id: null,
    updated_reason: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (!visitData.final_status_id) {
        return getToast({ status: 'error', title: 'Estatus es requerido' });
      }

      const endpoint = `${GlobalVariables.getURL()}sla/actions/${visitId}`;

      const response = await customAxios.patch(
        endpoint,
        {
          action_id: visitData.final_status_id,
          updated_reason: visitData.updated_reason,
        },
        HEADERS
      );

      if (response.status === 200) {
        getToast({
          status: 'success',
          title: 'Estatus actualizado correctamente',
        });

        handleClose();
      }
    } catch (error) {
      console.log(error);
      getToast({ status: 'error', title: error.response.data.message });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVisitData = async () => {
    const endpoint = `${GlobalVariables.getURL()}getVisitById/${visitId}`;
    const response = await customAxios.get(endpoint, HEADERS);

    return response.data.data;
  };

  const fetchStatusData = async () => {
    const endpoint = `${GlobalVariables.getURL()}sla/actions/${visitId}`;
    const response = await customAxios.get(endpoint, HEADERS);

    return response.data.data;
  };

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const [visit, finalStatuses] = await Promise.all([
        fetchVisitData(),
        fetchStatusData(),
      ]);

      setVisitData({
        ...visit,
        final_status_id: visit.final_status_id,
        updated_reason: '',
      });
      setStatusList(finalStatuses);
    } catch (error) {
      console.log(error);
      getToast({ status: error, title: error.response.data.message });
    } finally {
      setIsFetching(false);
    }
  };

  const handleResetFields = () => {
    setVisitData({
      final_status_id: null,
      updated_reason: '',
    });
  };

  const handleClose = () => {
    setShowModal(false);
    handleResetFields();
    refreshData();
  };

  useEffect(() => {
    if (!showModal) return;

    fetchData();
  }, [showModal]);

  return (
    <Dialog open={showModal} maxWidth='md' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Cambiar estatus
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
          width: 40,
          height: 40,
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='change-status-form' onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Final status field */}
            <Grid item xs={12}>
              {isFetching ? (
                <Skeleton variant='rounded' height={56} />
              ) : (
                <Autocomplete
                  options={statusList}
                  value={
                    statusList.find(
                      (s) => s.id === visitData.final_status_id
                    ) || null
                  }
                  getOptionLabel={(s) => s.name || ''}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(_, newValue) => {
                    setVisitData((prev) => ({
                      ...prev,
                      final_status_id: newValue ? newValue.id : null,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      disabled={isLoading}
                      {...params}
                      label='Estatus'
                      placeholder='Estatus...'
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              {isFetching ? (
                <Skeleton variant='rounded' height={112} />
              ) : (
                <TextField
                  disabled={isLoading}
                  multiline
                  fullWidth
                  required
                  label='Motivo de cambio'
                  placeholder='Motivo de cambio...'
                  rows={4}
                  type='text'
                  value={visitData.updated_reason}
                  onChange={(e) =>
                    setVisitData((prev) => ({
                      ...prev,
                      updated_reason: e.target.value,
                    }))
                  }
                />
              )}
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='change-status-form'
          type='submit'
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
        <Button variant='outlined' disabled={isLoading} onClick={handleClose}>
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Cerrar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeStatusModal;
